/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PersonList from "./PersonList";
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      routeStatus: 0,
      data : {}
    };
  }

  storeApiData = (data) => {
    this.setState({
      data
    })
  }
  changeRouteStatus = value => {
    this.setState(prevState => {
      return {
        routeStatus: value
      };
    });
  };
  render() {
    const { routeStatus } = this.state;
    return (
      <React.Fragment>
        <div className="wrapper position-relative">
          {routeStatus == 0 && (
            <PersonList storeApiData={this.storeApiData} changeRouteStatus={this.changeRouteStatus} />
         )}
         
        </div>
      </React.Fragment>
    );
  }
}
export default withRouter(Index);
